import { render, staticRenderFns } from "./CareRateCert.vue?vue&type=template&id=22e13463&"
import script from "./CareRateCert.vue?vue&type=script&lang=ts&"
export * from "./CareRateCert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports